module.exports = __webpack_public_path__ + "static/img/noodle2.d05584b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noodle/zh/noodle2.jpg
// module id = RKs6
// module chunks = 1